"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRequired = void 0;
const validation_1 = require("../validation/validation");
/**
 * @summary Creates a `Validation` for required fields.
 *
 * Creates a `Validation` for required fields. `false`, `null`, `undefined`, empty strings, whitespace strings and
 * empty arrays are considered empty and will fail the validation.
 *
 * @param {string | undefined} message
 * @param {IsRequiredOptions} options
 * @returns {Validation}
 *
 * @see Validation
 */
function isRequired(message, options) {
    return (0, validation_1.validation)(message ?? 'The given value cannot be empty.', (value) => {
        if (typeof value === 'boolean') {
            return value;
        }
        if (typeof value === 'string') {
            if (options?.allowWhitespace ?? false) {
                return (value.length ?? 0) > 0;
            }
            return (String.prototype.trim.call(value).length ?? 0) > 0;
        }
        if (Array.isArray(value)) {
            return (value.length ?? 0) > 0;
        }
        return value != null;
    });
}
exports.isRequired = isRequired;
